export default __webpack_public_path__ + "static/media/Message Send Sequence.ed167625.svg";